konnyScript(function($){
  
  var swiper = new Swiper("#flex_detail_swiper_slide1", {
      slidesPerView: 'auto',
      slidesPerGroup: 1,
      spaceBetween: '2.9%',
      loop: false,
      autoHeight : false,
      scrollbar: {
          el: '#flex_detail_swiper_slide1 .swiper-scrollbar',
      },
      pagination: {
          el: '#flex_detail_swiper_slide1 .swiper-pagination',
      },
      navigation: {
          nextEl: '#flex_detail_swiper_slide1 .swiper-button-next',
          prevEl: '#flex_detail_swiper_slide1 .swiper-button-prev',
      },
  });

  var fdHeightArray = $("#flex_detail_swiper_slide1 .swiper-slide").map( function(){ 
      return  $(this).height(); 
  }).get(); 
  var fdMaxHeight = Math.max.apply( Math, fdHeightArray); 
  $("#flex_detail_swiper_slide1 .swiper-slide").height(fdMaxHeight);

  $(window).resize(function(){
    $("#flex_detail_swiper_slide1 .swiper-slide").css('height','unset');
    var fdHeightArray = $("#flex_detail_swiper_slide1 .swiper-slide").map( function(){ 
        return  $(this).height(); 
    }).get(); 
    var fdMaxHeight = Math.max.apply( Math, fdHeightArray); 
    $("#flex_detail_swiper_slide1 .swiper-slide").height(fdMaxHeight);
  }); 


  
  
  var swiper = new Swiper("#flex_detail_swiper_slide2", {
    slidesPerView:1,
    slidesPerGroup:1,
    centeredSlides:true,
    loop:true,
    effect:'fade',
    speed:0,
    autoplay:{
      delay:1000,
      disableOnInteraction:false,
    },
  });
  
  var swiper = new Swiper("#flex_detail_swiper_slide3", {
      slidesPerView: 'auto',
      slidesPerGroup: 1,
      spaceBetween: '1.4%',
      loop:true,
      speed:2500,
      autoplay:{
        delay:0,
        disableOnInteraction:false,
      },
      scrollbar: {
          el: '#flex_detail_swiper_slide3 .swiper-scrollbar',
      },
      pagination: {
          el: '#flex_detail_swiper_slide3 .swiper-pagination',
      },
      navigation: {
          nextEl: '#flex_detail_swiper_slide3 .swiper-button-next',
          prevEl: '#flex_detail_swiper_slide3 .swiper-button-prev',
      },
  });
});